import PropTypes from 'prop-types';
import { translationPropType } from '@eb/i18n';

import { gettext } from '@eb/i18n';

import { HEADER_IMAGES_PROPTYPES } from './header';
import {
    ONLINE_BANNER_URL,
    TLD_AUSTRALIA,
    TLD_CANADA,
    TLD_GLOBALLY,
    TLD_IRELAND,
    TLD_MEXICO,
    TLD_UNITED_KINGDOM,
    TLD_UNITED_STATES,
} from './constants';

const WELLNESS_BANNER_URL =
    'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F110853149%2F240387405737%2F1%2Foriginal.20200908-210009?w=1017&auto=format%2Ccompress&q=75&sharp=10&s=00c689f92a69976d38533b1307929d17';

const CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES = {
    collectionLink:
        'https://www.eventbrite.com/c/the-best-online-events-to-attend-right-from-your-home-cwwqhpk/',
    collectionPrefix: 'cwwqhpk',
    shouldShowCustomHeader: true,
    customHeaderPriority: 1000,
};

export const SEASONAL_CONTENT = {
    default: {
        coronavirus: {
            startDate: {
                day: 18,
                month: 3,
                year: 2020,
            },
            endDate: {
                day: 18,
                month: 3,
                year: 2220,
            },
            key: 'coronavirus',
            tlds: [TLD_GLOBALLY],
            tldsExcluded: [],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: true,
            alwaysShow: true,
            customHeaderPriority: 0,
            tldOverrides: {
                [TLD_AUSTRALIA]: {
                    collectionLink:
                        '/c/do-well-take-care-of-yourself-and-your-community-during-eventbrites-online-wellness-festival-cwxmbwp/',
                    headerImages: {
                        mobile: WELLNESS_BANNER_URL,
                        tablet: WELLNESS_BANNER_URL,
                        desktop: WELLNESS_BANNER_URL,
                        twok: WELLNESS_BANNER_URL,
                    },
                    // no gettext since shown in English-speaking TLDs only
                    combinedHeaderTitleAndCta:
                        '<div class="feed-header__title-top">Eventbrite\'s online</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">wellness festival</div>',
                },
                [TLD_CANADA]: {
                    collectionLink:
                        '/c/do-well-take-care-of-yourself-and-your-community-during-eventbrites-online-wellness-festival-cwxmbwp/',
                    headerImages: {
                        mobile: WELLNESS_BANNER_URL,
                        tablet: WELLNESS_BANNER_URL,
                        desktop: WELLNESS_BANNER_URL,
                        twok: WELLNESS_BANNER_URL,
                    },
                    combinedHeaderTitleAndCta:
                        '<div class="feed-header__title-top">Eventbrite\'s online</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">wellness festival</div>',
                },
                [TLD_IRELAND]: {
                    collectionLink:
                        '/c/do-well-take-care-of-yourself-and-your-community-during-eventbrites-online-wellness-festival-cwxmbwp/',
                    headerImages: {
                        mobile: WELLNESS_BANNER_URL,
                        tablet: WELLNESS_BANNER_URL,
                        desktop: WELLNESS_BANNER_URL,
                        twok: WELLNESS_BANNER_URL,
                    },
                    // no gettext since shown in English-speaking TLDs only
                    combinedHeaderTitleAndCta:
                        '<div class="feed-header__title-top">Eventbrite\'s online</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">wellness festival</div>',
                },
                [TLD_UNITED_KINGDOM]: {
                    collectionLink:
                        '/c/do-well-take-care-of-yourself-and-your-community-during-eventbrites-online-wellness-festival-cwxmbwp/',
                    headerImages: {
                        mobile: WELLNESS_BANNER_URL,
                        tablet: WELLNESS_BANNER_URL,
                        desktop: WELLNESS_BANNER_URL,
                        twok: WELLNESS_BANNER_URL,
                    },
                    // no gettext since shown in English-speaking TLDs only
                    combinedHeaderTitleAndCta:
                        '<div class="feed-header__title-top">Eventbrite\'s online</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">wellness festival</div>',
                },
                [TLD_UNITED_STATES]: {
                    collectionLink:
                        '/c/do-well-take-care-of-yourself-and-your-community-during-eventbrites-online-wellness-festival-cwxmbwp/',
                    headerImages: {
                        mobile: WELLNESS_BANNER_URL,
                        tablet: WELLNESS_BANNER_URL,
                        desktop: WELLNESS_BANNER_URL,
                        twok: WELLNESS_BANNER_URL,
                    },
                    // no gettext since shown in English-speaking TLDs only
                    combinedHeaderTitleAndCta:
                        '<div class="feed-header__title-top">Eventbrite\'s online</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">wellness festival</div>',
                },
            },
        },
        halloween: {
            key: 'halloween',
            tabName: 'Halloween',
            eventSearchQ: gettext('Halloween day of the dead'),
            startDate: {
                day: 1,
                month: 10,
            },
            endDate: {
                day: 1,
                month: 11,
            },
            tlds: [TLD_GLOBALLY],
            tldsExcluded: [TLD_MEXICO],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: true,
            alwaysShow: false,
        },
        thanksgiving: {
            key: 'thanksgiving',
            tabName: 'Thanksgiving',
            eventSearchQ: gettext(
                'Thankgiving turkey volunteer turkey day turkey trot',
            ),
            startDate: {
                day: 5,
                month: 11,
            },
            endDate: {
                day: 28,
                month: 11,
            },
            tlds: [TLD_GLOBALLY],
            tldsExcluded: [],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: true,
            alwaysShow: false,
        },
        NYE: {
            key: 'NYE',
            tabName: gettext("New Year's eve"),
            eventSearchQ: gettext("NYE New Year's Eve New Year"),
            startDate: {
                day: 10,
                month: 12,
                year: 2020,
            },
            endDate: {
                day: 4,
                month: 1,
                year: 2021,
            },
            tlds: [TLD_GLOBALLY],
            tldsExcluded: [],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: true,
            alwaysShow: false,
        },
        mothersDay: {
            key: 'mothersDay',
            tabName: gettext("Mother's day"),
            eventSearchQ: gettext("mother's day"),
            onlineOnly: true,
            startDate: {
                day: 8,
                month: 5,
            },
            endDate: {
                day: 11,
                month: 5,
            },
            tlds: [TLD_GLOBALLY],
            tldsExcluded: [],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: true,
            alwaysShow: false,
        },
        pride: {
            key: 'pride',
            tabName: gettext('Pride'),
            eventSearchQ: gettext('pride'),
            onlineOnly: false,
            startDate: {
                day: 28,
                month: 5,
                year: 2020,
            },
            endDate: {
                day: 30,
                month: 6,
                year: 2020,
            },
            tlds: [TLD_GLOBALLY],
            tldsExcluded: [],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: true,
            alwaysShow: false,
        },
        fathersDay: {
            key: 'fathersDay',
            tabName: gettext("Father's Day"),
            eventSearchQ: gettext("Father's Day Dad dad's day"),
            onlineOnly: false,
            startDate: {
                day: 16,
                month: 6,
                year: 2020,
            },
            endDate: {
                day: 21,
                month: 6,
                year: 2020,
            },
            tlds: [TLD_GLOBALLY],
            tldsExcluded: [],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: true,
            customHeaderPriority: 0,
            alwaysShow: false,
        },
        julyFourth: {
            key: 'julyFourth',
            tabName: gettext('4 of July'),
            eventSearchQ: gettext(
                'July 4 4th of July Independence Day fireworks',
            ),
            onlineOnly: false,
            startDate: {
                day: 22,
                month: 6,
                year: 2020,
            },
            endDate: {
                day: 5,
                month: 7,
                year: 2020,
            },
            tlds: [TLD_GLOBALLY],
            tldsExcluded: [],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: false,
            alwaysShow: false,
        },
        laborDay: {
            key: 'laborDay',
            tabName: gettext('Labor day'),
            eventSearchQ: gettext('labor day'),
            onlineOnly: false,
            startDate: {
                day: 21,
                month: 8,
            },
            endDate: {
                day: 7,
                month: 9,
            },
            tlds: [TLD_UNITED_STATES, TLD_CANADA],
            tldsExcluded: [],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: false,
            alwaysShow: false,
        },
    },
    // New York
    '85977539': {
        coronavirus: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        mothersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        pride: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        fathersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        julyFourth: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        laborDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        halloween: {
            collectionLink:
                'https://www.eventbrite.com/c/halloween-parties-nyc-cgrkdxb/',
            collectionPrefix: 'cgrkdxb',
            shouldShowCustomHeader: false,
        },
        thanksgiving: {
            collectionLink:
                'https://www.eventbrite.com/c/volunteer-opportunities-new-york-city-cwtfwbg/',
            collectionPrefix: 'cwtfwbg',
            shouldShowCustomHeader: true,
        },
        NYE: {
            collectionLink:
                'https://www.eventbrite.com/c/made-for-those-who-do-new-years-eve-in-new-york-city-cwtgckw/',
            collectionPrefix: 'cwtgckw',
            shouldShowCustomHeader: true,
        },
    },
    // San Francisco
    '85922583': {
        coronavirus: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        mothersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        pride: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        fathersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        julyFourth: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        laborDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        halloween: {
            collectionLink:
                'https://www.eventbrite.com/c/the-best-halloween-parties-in-san-francisco-cgrkyyw/',
            collectionPrefix: 'cgrkyyw',
            shouldShowCustomHeader: false,
        },
        thanksgiving: {
            collectionLink:
                'https://www.eventbrite.com/c/volunteer-opportunities-san-francisco-cwtdtpd/',
            collectionPrefix: 'cwtdtpd',
            shouldShowCustomHeader: true,
        },
        NYE: {
            collectionLink:
                'https://www.eventbrite.com/c/san-franciscos-best-new-years-eve-parties-and-shows-cwtgmcb/',
            collectionPrefix: 'cwtgmcb',
            shouldShowCustomHeader: true,
        },
    },
    // Los Angeles
    '85923517': {
        coronavirus: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        mothersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        pride: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        fathersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        julyFourth: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        laborDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        halloween: {
            collectionLink:
                'https://www.eventbrite.com/c/the-best-halloween-parties-in-los-angeles-cgrkwgr/',
            collectionPrefix: 'cgrkwgr',
            shouldShowCustomHeader: false,
        },
        thanksgiving: {
            collectionLink:
                'https://www.eventbrite.com/c/volunteer-opportunities-los-angeles-cwtgchd/',
            collectionPrefix: 'cwtgchd',
            shouldShowCustomHeader: true,
        },
        NYE: {
            collectionLink:
                'https://www.eventbrite.com/c/los-angeless-best-new-years-eve-parties-and-shows-cwtgcpk/',
            collectionPrefix: 'cwtgcpk',
            shouldShowCustomHeader: true,
        },
    },
    // Washington DC
    '85931779': {
        coronavirus: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        mothersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        pride: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        fathersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        julyFourth: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        laborDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        halloween: {
            collectionLink:
                'https://www.eventbrite.com/c/the-best-halloween-parties-in-washington-dc-cgrkwmk/',
            collectionPrefix: 'cgrkwmk',
            shouldShowCustomHeader: false,
        },
        thanksgiving: {
            collectionLink:
                'https://www.eventbrite.com/c/volunteer-opportunities-washington-dc-cwtgckk/',
            collectionPrefix: 'cwtgckk',
            shouldShowCustomHeader: true,
        },
        NYE: {
            collectionLink:
                'https://www.eventbrite.com/c/washington-dcs-best-new-years-eve-parties-and-shows-cwtgcrb/',
            collectionPrefix: 'cwtgcrb',
            shouldShowCustomHeader: true,
        },
    },
    // Chicago
    '85940195': {
        coronavirus: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        mothersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        pride: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        fathersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        julyFourth: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        laborDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        halloween: {
            collectionLink:
                'https://www.eventbrite.com/c/the-best-halloween-parties-in-chicago-cgrkwrr/',
            collectionPrefix: 'cgrkwrr',
            shouldShowCustomHeader: false,
        },
        thanksgiving: {
            collectionLink:
                'https://www.eventbrite.com/c/volunteering-opportunities-chicago-cwtgckd/',
            collectionPrefix: 'cwtgckd',
            shouldShowCustomHeader: true,
        },
        NYE: {
            collectionLink:
                'https://www.eventbrite.com/c/chicagos-best-new-years-eve-parties-and-shows-cwtgcwp/',
            collectionPrefix: 'cwtgcwp',
            shouldShowCustomHeader: true,
        },
    },
    // Philadelphia
    '101718083': {
        coronavirus: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        mothersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        pride: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        fathersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        julyFourth: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        laborDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        halloween: {
            collectionLink:
                'https://www.eventbrite.com/c/best-halloween-parties-philadelphia-chkwzwk/',
            collectionPrefix: 'chkwzwk',
            shouldShowCustomHeader: false,
        },
        thanksgiving: {
            collectionLink: '',
            collectionPrefix: '',
        },
        NYE: {
            collectionLink: '',
            collectionPrefix: '',
            shouldShowCustomHeader: false,
        },
    },
    // Atlanta
    '85936429': {
        coronavirus: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        mothersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        pride: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        fathersDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        julyFourth: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        laborDay: CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES,
        NYE: {
            collectionLink:
                'https://www.eventbrite.com/c/atlantas-best-new-years-eve-parties-and-shows-cwtgcxk/',
            collectionPrefix: 'cwtgcxk',
            shouldShowCustomHeader: true,
        },
    },
};

export const BASE_SEASONAL_CONTENT_PROPTYPES = {
    byDate: PropTypes.shape({
        key: PropTypes.string,
        startDate: PropTypes.shape({
            day: PropTypes.number,
            month: PropTypes.number,
        }),
        endDate: PropTypes.shape({
            day: PropTypes.number,
            month: PropTypes.number,
        }),
        eventSearchQ: translationPropType,
        onlineOnly: PropTypes.bool,
        forceDisable: PropTypes.bool,
        headerImages: PropTypes.shape(HEADER_IMAGES_PROPTYPES),
        attribution: PropTypes.string,
        cta: PropTypes.string,
        linkLabel: translationPropType,
    }),
    byPlace: PropTypes.shape({
        collectionLink: PropTypes.string,
        collectionPrefix: PropTypes.string,
        shouldShowCustomHeader: PropTypes.bool,
        customHeaderPriority: PropTypes.number,
    }),
};
